import React from "react";
import HeroSection from "./sections/HeroSection";
import ProductsSection from "./sections/ProductsSection";
import MidPageCTA from "./sections/MidPageCTA";
import BenefitsSection from "./sections/BenefitsSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import FormSection from "./sections/FormSection";
import FinalCTASection from "./sections/FinalCTASection";
import StickyMobileCTA from "./sections/StickyMobileCTA";
import GallerySection from "./sections/GallerySection";
const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <ProductsSection />
      <MidPageCTA />
      <BenefitsSection />
      <GallerySection />
      <TestimonialsSection />
      <FormSection />
      <FinalCTASection />
      <StickyMobileCTA />
    </>
  );
};

export default LandingPage;
